// src/components/layout/Layout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header'; // Assuming Header is in the same directory
import Footer from './Footer'; // Import the new Footer
import './Layout.css'; // Import the CSS

const Layout: React.FC = () => {
  return (
    <div className="layout-container">
      <Header /> {/* Header remains */}
      <main className="layout-content">
        <Outlet /> {/* Renders the matched route component */}
      </main>
      <Footer /> {/* Add the Footer */}
    </div>
  );
};

export default Layout;
